import { useMutation } from "@tanstack/react-query";
import { updateFaqStatus } from "../api/updateFaqStatus";
import { invalidateFaqsListByFaqGroupQuery } from "../queries/useFaqsListByFaqGroupQuery";
import { UpdateFaqStatusParams } from "../types";

export const useUpdateFaqStatusMutation = () => {
  return useMutation({
    mutationFn: async ({
      faqGroupId,
      faqId,
      status,
    }: UpdateFaqStatusParams) => {
      return await updateFaqStatus(faqGroupId, faqId, status);
    },
    onSuccess: (_, { faqGroupId }) => {
      invalidateFaqsListByFaqGroupQuery(faqGroupId);
    },
    onError: (e) => {
      console.error("Error occurred when updating faq", e);
    },
  });
};
